import React from 'react';
import { Chart as PrimeChart } from 'primereact/chart';
import styles from './Chart.module.css';

export interface ChartProps {
  /**
   * Chart data object (PrimeReact Chart data format)
   */
  data: any;
  /**
   * Chart options object (PrimeReact Chart options format)
   * If not provided, default options adapted to the Design System will be used.
   */
  options?: any;
  /**
   * Type of chart. Defaults to 'bar'.
   */
  type?: 'bar' | 'pie' | 'doughnut' | 'line' | 'polarArea' | 'radar';
  /**
   * Optional custom className for the container
   */
  className?: string;
  /**
   * Title of the chart
   */
  title?: string;
}

/**
 * Chart component wrapping PrimeReact's Chart to apply Modulare Design System tokens.
 */
export const Chart: React.FC<ChartProps> = ({
  data,
  options,
  type = 'bar',
  className = '',
  title,
}) => {
  // Default options for design system consistency if not explicitly provided
  const defaultOptions = {
    maintainAspectRatio: false,
    aspectRatio: 0.8,
    plugins: {
      legend: {
        labels: {
          color: 'var(--color-ui-text-secondary)'
        }
      }
    },
    scales: type === 'bar' || type === 'line' ? {
      x: {
        ticks: {
          color: 'var(--color-ui-text-secondary)',
        },
        grid: {
          color: 'var(--color-ui-border-default)',
        }
      },
      y: {
        ticks: {
          color: 'var(--color-ui-text-secondary)'
        },
        grid: {
          color: 'var(--color-ui-border-default)',
        }
      }
    } : undefined
  };

  const finalOptions = options || defaultOptions;

  return (
    <div className={`${styles.chartContainer} ${className}`}>
      {title && <h3 className={styles.title}>{title}</h3>}
      <div className={styles.chartWrapper}>
        <PrimeChart type={type} data={data} options={finalOptions} className="w-full h-full" />
      </div>
    </div>
  );
};

export default Chart;
